import { Box, chakra } from '@chakra-ui/react';
import React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const Container = ({ children, className }: Props) => {
  return (
    <Box
      className={className}
      width="100%"
      minWidth={{ base: '100%', lg: 'fit-content' }}
      maxWidth="100vw"
      m="0 auto"
      bg="gray.50"
      minH="100vh"
      overflowX="hidden"
      position="relative"
    >
      {children}
    </Box>
  );
};

export default React.memo(chakra(Container));